import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { Wallet } from 'iconoir-react';
import { useTranslation } from 'react-i18next';

interface CampaignBudgetNoticeProps {
  campaignName: string;
}

/**
 * Shown instead of the daily amount input when the chosen campaign holds its
 * budget centrally (CBO). Meta rejects an ad set budget under such a campaign,
 * so the brand only picks the duration — and is told why.
 */
export function CampaignBudgetNotice({ campaignName }: CampaignBudgetNoticeProps) {
  const { t } = useTranslation();

  return (
    <Box border="1px solid" borderColor="border.muted" bg="bg.subtle" rounded="lg" px={3} py={2.5}>
      <HStack align="flex-start" gap={2}>
        <Icon size="sm" color="fg.muted" mt={0.5}>
          <Wallet />
        </Icon>
        <VStack align="stretch" gap={1}>
          <Text fontSize="sm" fontWeight="semibold">
            {t('mentions.boost.setup.campaignBudget.title')}
          </Text>
          <Text fontSize="xs" color="fg.muted">
            {t('mentions.boost.setup.campaignBudget.description', { campaign: campaignName })}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
}
